import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { FleetService } from '../../../services/fleet/fleet.service';
import { TransporterService } from '../../../services/transporter/transporter.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-addfleet',
  templateUrl: './addfleet.component.html',
  styleUrls: ['./addfleet.component.scss']
})
export class AddfleetComponent implements OnInit {

  fleetForm: FormGroup;
  vehicleMake: string;
  vehicleModel: string;
  vehicleYear: string;
  vehicleType: string;
  vehicleLicenseNumber: string;
  vehicleIdNumber: string;
  vehicleRegistrationDate: string;
  vehicleOdometerReading: string;
  carryingType: string;
  bodyHeight: Number;
  bodyLength: Number;
  bodyWidth: Number;
  bodyVolumetricCapacity: Number;
  bodyWeightCapacity: Number;
  description: string;
  transporter: {};
  ownership: string;
  submitText: string;
  selectedTransporter: string


  //activity log
  activityLog = [];
  activityCreatedLog = [];
  activityUpdatedLog = [];
  fleetAddedBy: string;
  fleetCreationDate: string;
  fleetUpdationDate: string;
  alltransporters = [];
  constructor(
    public fleetService: FleetService,
    public transporterservice: TransporterService,
    private formBuilder: FormBuilder,
    public snackBar: MatSnackBar,
    public router: Router,
    private datePipe: DatePipe

  ) {

    this.submitText = "Submit";
    this.fleetForm = formBuilder.group({
      'vehicleMake': [null, [
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9_ ]+$")
      ]],
      'vehicleModel': [null, [
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9_ ]+$")
      ]],
      'vehicleYear': [null, [
        Validators.pattern('^[0-9]*$')
      ]],
      'vehicleType': [null, [
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9_ ]+$")
      ]],
      'vehicleLicenseNumber': [null, [
        Validators.required,
        Validators.pattern("^[a-zA-Z0-9_ ]+$")
      ]],
      'vehicleIdNumber': [null, Validators.pattern("^[a-zA-Z0-9_ ]+$")],
      'vehicleRegistrationDate': [null],
      'vehicleOdometerReading': [null, [
        Validators.pattern('^[0-9]*$')
      ]],
      'carryingType': [null],
      'bodyHeight': [null, [
        Validators.pattern('^[0-9]{1,9}(,[0-9]{10})*(([\\.,]{1}[0-9]*)|())$')
      ]],
      'bodyLength': [null, [
        Validators.pattern('^[0-9]{1,9}(,[0-9]{10})*(([\\.,]{1}[0-9]*)|())$')
      ]],
      'bodyWidth': [null, [
        Validators.pattern('^[0-9]{1,9}(,[0-9]{10})*(([\\.,]{1}[0-9]*)|())$')
      ]],
      'bodyVolumetricCapacity': [null, [
        Validators.pattern('^[0-9]{1,9}(,[0-9]{10})*(([\\.,]{1}[0-9]*)|())$')
      ]],
      'bodyWeightCapacity': [null, [
        Validators.pattern('^[0-9]{1,9}(,[0-9]{10})*(([\\.,]{1}[0-9]*)|())$')
      ]],
      'addDocument': [null],
      'description': [null],
      'transporter': [null,
      Validators.required
    ],
      'ownership': [null],

    })

  }
  openSnackBar(message) {
    let extraClasses;
    this.snackBar.open(message, 'ok', {
      duration: 2000,
      panelClass: ['extraClasses']
    });
  }

  ngOnInit() {
    this.getAllFleets();
    this.getTransporter();
    //this.getTransoprterforfleet();
  }
 
  selectRegDate(event){
    let date = new Date(event.value);
    this.fleetForm.value.vehicleRegistrationDate = this.datePipe.transform(date, 'yyyy-MM-dd');
  }

  // getTransoprterforfleet(){
  //   this.transporterservice.getTransporterByName("SinghLLP").subscribe(transporterDetails=>{
  //    console.log("trnbnabanm",transporterDetails);
  //    this.selectedTransporter = transporterDetails;
  //   })
  // }

  getTransporter(){
    this.transporterservice.getAllTransporters().subscribe(transporterDetails=>{
      this.alltransporters = transporterDetails;
      console.log("alltransporters",this.alltransporters);
      this.alltransporters.sort(function(a, b){
        let transporteName1=a.transporterName.toLowerCase(), transporteName2=b.transporterName.toLowerCase()
        if (transporteName1 < transporteName2) //sort string ascending
            return -1 
        if (transporteName1 > transporteName2)
            return 1
        return 0 
    });
    });
  }
  getAllFleets() {
    //call get all fleet service here
    this.fleetService.getallFleets().subscribe(res => {
      console.log(res);
      for (let i = 0; i < 3; i++) {
        if(res[i]){
        this.activityCreatedLog.push({
          vehicleLicenseNumber: res[i].vehicleLicenseNumber,
          createdBy: res[i].updatedByusername,
          creadtedDate: this.datePipe.transform(res[i].creationDateTime, 'yyyy-MM-dd'),
          creadtedTime: res[i].creationDateTime,
        });
        this.activityUpdatedLog.push({
          vehicleLicenseNumber: res[i].vehicleLicenseNumber,
          updatedBy: res[i].updatedByusername,
          updatedDate: this.datePipe.transform(res[i].updatedDateTime, 'yyyy-MM-dd'),
          updatedTime: res[i].updatedDateTime
        });
        console.log(this.activityCreatedLog);
      }
    }
    }, Error => {
      console.log(Error);
    });
  }

  addFleet() {
    this.submitText = "Submitting"
    console.log("form",this.fleetForm.value);

    //call fleet service here
    this.fleetService.addFleet(this.fleetForm.value).subscribe(res => {
      console.log("submitted form",res);
      this.submitText = "Submit";
      this.openSnackBar("Fleet: " + this.fleetForm.value.vehicleLicenseNumber + " added successfully");
      this.fleetForm.reset();
      this.router.navigateByUrl('/managefleet')

    }, Error => {
      console.log(Error);
      this.submitText = "Submit";
      this.openSnackBar("Something went wrong ! Please try again later");
      this.fleetForm.reset();
    })
  }
}
